// extracted by mini-css-extract-plugin
export var buttonContent = "_35-0";
export var centered = "_35-1";
export var centeredFlex = "_35-2";
export var errorText = "_35-3";
export var icon = "_35-4";
export var iconButtonContent = "_35-5";
export var monospace = "_35-6";
export var padded = "_35-7";